import React, { useContext } from 'react';
import PropTypes from 'constants/PropTypes';
import { connect } from 'react-redux';
import { getFormValues } from 'redux-form';
import Spinner from 'components/Spinner/Spinner';
import { ToastViewer, toastCreator } from 'components/Toast';
import { isEnabledFeatureFlag } from 'libs/featureFlagLookUp';
import { FeatureFlagsContext } from 'components/FeatureFlags';
import ldFlags from 'constants/ldFlags';
import ForgotPasswordForm from '../components/ForgotPasswordForm';
import ForgotPasswordFormNew from '../components/ForgotPasswordFormNew';
import ForgotPasswordConfirm from '../components/ForgotPasswordConfirm';
import { submitAction, submitUsernameAction } from '../actions/submit';

const formValues = getFormValues('forgotPasswordForm');

const mapStateToProps = (state) => {
    const { forgotPassword } = state;
    const props = {
        loading: forgotPassword.get('loading'),
        success: forgotPassword.get('success'),
        email: forgotPassword.get('email'),
        reason: forgotPassword.get('reason'),
        ...formValues(state),
    };
    return props;
};

const mapDispatchToProps = (dispatch) => ({
    submit: ({ email }) => dispatch(submitAction(email)), // TODO: Remove when https://ofx.atlassian.net/browse/DXP-7100 is LIVE
    submitWithUsername: ({ email }) => dispatch(submitUsernameAction(email)),
});

export const ForgotPasswordContainer = ({
    success,
    email,
    submit,
    submitWithUsername,
    loading,
    reason,
}) => {
    const { flags } = useContext(FeatureFlagsContext);
    const isEnabledChangeEmailFieldToUsername = isEnabledFeatureFlag(
        flags,
        ldFlags.changeEmailFieldToUsername,
    );

    const renderForgotPasswordForm = () =>
        isEnabledChangeEmailFieldToUsername ? (
            <ForgotPasswordFormNew submitForm={submitWithUsername} loading={loading} />
        ) : (
            <ForgotPasswordForm submitForm={submit} loading={loading} />
        );

    return (
        <div className="ofx-panel ofx-panel-primary">
            <ToastViewer />
            <Spinner loading={loading} />
            {/* Show the success message and the Return to Login link */}
            {success && <ForgotPasswordConfirm email={email} onSuccess={toastCreator.success} />}

            {/* Show the form on page load (reason === 'undefined') 
            and on error (reason === 'error' */}
            {!success && reason !== '' && renderForgotPasswordForm()}
        </div>
    );
};

ForgotPasswordContainer.propTypes = {
    submit: PropTypes.func,
    submitWithUsername: PropTypes.func,
    success: PropTypes.bool,
    email: PropTypes.string,
    reason: PropTypes.string,
    loading: PropTypes.bool,
};

export default connect(mapStateToProps, mapDispatchToProps)(ForgotPasswordContainer);
